import React from 'react'

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  children: React.ReactNode
  className?: string
}

export const Select: React.FC<SelectProps> = ({ 
  children, 
  className = '', 
  ...props 
}) => {
  return (
    <select
      className={`input-modern ${className}`}
      {...props}
    >
      {children}
    </select>
  )
} 